import "../../pages/new/new.scss"
import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getAllStudents, getBatches, getAllBatchStudents,getAllBatchTermStudents } from '../../services/studentService';
import { getAllTerms } from '../../services/termService';
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';


export const AssignTerm = () => {
    const navigate = useNavigate();
    const [students, setStudents] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [batches, setBatches] = useState([]);
    const [batchValue, setBatchValues] = useState();
    const [terms, setTerms] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [errors, setErrors] = useState({});

    const fetchBatches = async () => {
        try {
            const batchdata = await getBatches();
          //  console.log(batchdata);
            setBatches(batchdata.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchBatchStudents = async (batch) => {
        try {
            const data = await getAllBatchStudents(batch);
            setStudents(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchBatchTermStudents = async (batch,termId) => {
        try {
            const data = await getAllBatchTermStudents(batch,termId);
            setStudents(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchTerms = async () => {
        try {
            const data = await getAllTerms();
          //  console.log(data);
            setTerms(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchBatches();
        fetchTerms();
    }, []);
    const handleBatchChange = (event) => {
        const { name, value } = event.target;
       // console.log(event.target.value);
        setBatchValues(event.target.value);
        if(selectedTerm)
            fetchBatchTermStudents(event.target.value,selectedTerm);
        else
            fetchBatchStudents(event.target.value);
        
    };
    const handleStudentChange = (event) => {
        const selectedValues = Array.from(event.target.selectedOptions, option => option.value);
        setSelectedStudents(selectedValues);
       
    };

    const handleTermChange = (event) => {
       
        setSelectedTerm(event.target.value);
        if(batchValue)
        fetchBatchTermStudents(batchValue,event.target.value);
        else
        fetchBatchTermStudents("",event.target.value);

        

       
    };
    const validateForm = () => {
        const errors = {};
        if (!batchValue) {
            errors.batch = 'Batch is required';
        }
        if (!selectedTerm) {
            errors.term = 'Term is required';
        }
        if(!selectedStudents || selectedStudents.length === 0){
            errors.students='Select some students';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        try {
            
           // console.log(selectedStudents);
          //  console.log(selectedTerm);
            var assignTerm = {
                studentEnrollmentNo: selectedStudents,
                termId: selectedTerm
            }
            var response = await axiosInstance.post('/assignStudentTerm', assignTerm,{showToastOnResponse: true});
            navigate('/');
            
        } catch (error) {
            console.log('Error saving termcourse. Please try again later.');
            console.log(error);
        }
    };
    const goBack = (e) => {
        navigate('/');
    };
    return (
        <div>
            <div className="top">
                <h1>{'Assigned Student Terms'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>
                        <div className="formInput">
                            <label>Select Batch </label>
                            <select id="styled-dropdown"
                                name="batch"
                                value={batchValue}
                                onChange={handleBatchChange}
                            >
                                <option value="">All Batches</option>
                                {batches && batches.map(option => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                            {errors.batch && <div className="error-text">{errors.batch}</div>}
                        </div>

                        <div className="formInput">
                            <label>Select Term </label>
                            <select id="styled-dropdown"
                                name="term"
                                value={selectedTerm}
                                onChange={handleTermChange}
                            >
                                <option value="">All Terms</option>
                                {terms && terms.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                            {errors.term && <div className="error-text">{errors.term}</div>}
                        </div>
                        <div className="formInput">
                            <label>Select Students </label>
                            <select id="styled-dropdown"
                                name="students"
                                multiple
                                value={selectedStudents}
                                onChange={handleStudentChange}
                            >
                                
                                {students && students.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.enrollmentNumber} : {option.name}
                                    </option>
                                ))}
                            </select>
                            {errors.students && <div className="error-text">{errors.students}</div>}
                        </div>
                        <div className="buttons">
           <button type="submit">{'Save'}</button>
           <button onClick={goBack}>Back</button>
           </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


